// extracted by mini-css-extract-plugin
export var avatarContainer = "_i5-0";
export var avatarTypingWave = "_i5-i";
export var gray = "_i5-f";
export var green = "_i5-c";
export var icon = "_i5-9";
export var image = "_i5-1";
export var lg = "_i5-6";
export var md = "_i5-5";
export var presenceDot = "_i5-b";
export var red = "_i5-d";
export var sm = "_i5-4";
export var status = "_i5-a";
export var typingDot = "_i5-h";
export var typingPill = "_i5-g";
export var xl = "_i5-7";
export var xs = "_i5-3";
export var xxl = "_i5-8";
export var xxs = "_i5-2";
export var yellow = "_i5-e";